<template>
  <input
    ref="input"
    type="number"
    autocomplete="off"
    class="form-control"
    :class="cssClassNames"
    :value="value"
    :placeholder="placeholder"
    :maxlength="maxlength"
    :min="min"
    :max="max"
    @input="$emit('input', $event.target.value)"
  >
</template>

<script>
const props = {
  value: {
    type: [String, Number]
  },
  invalid: {
    type: Boolean,
    default: false
  },
  focus: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: 'micro'
  },
  placeholder: {
    type: String,
    default: ''
  },
  maxlength: {
    type: String,
    default: '255'
  },
  min: {
    type: Number,
    default: undefined
  },
  max: {
    type: Number,
    default: undefined
  }
};

export default {
  name: 'VInteger',
  props,
  emits: ['input'],
  computed: {
    cssClassNames() {
      return {
        'form-control_invalid': this.invalid,
        [`form-control_size_${this.size}`]: Boolean(this.size)
      };
    }
  },
  mounted() {
    if (this.focus) {
      this.makeFocus();
    }
  },
  methods: {
    makeFocus() {
      // пропс назвали `focus` очень встрато получилось, но менять пропс довольно опасно
      this.$refs.input.focus();
    }
  }
};
</script>

<i18n lang="json">{}</i18n>
